export default __webpack_public_path__ + "static/media/clipboard-alt.37b4d9d0.svg";